import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { useEvidentlyFeatures } from '../../../evidentlyFeatureFlags'
import { EVIDENTLY_FLAG } from '~/util/constants/keys'
import './styles.scss'

export const AutomationNotification = ({ companySettings, handleAction }) => {
  const [
    onlyConflictAutoSyncNotification,
    setOnlyConflictAutoSyncNotification,
  ] = React.useState(false)
  const flags = useEvidentlyFeatures()

  React.useEffect(() => {
    const { onlyConflictAutoSyncNotification } =
      companySettings?.dss?.notifications || {}

    const onlyConflictFlag =
      typeof onlyConflictAutoSyncNotification === 'undefined'
        ? true
        : onlyConflictAutoSyncNotification

    setOnlyConflictAutoSyncNotification(onlyConflictFlag)
  }, [companySettings])

  if (!flags[EVIDENTLY_FLAG.COLLABORATION]) {
    return <></>
  }

  const handleOnChange = (toggle, setLocalState, isConflictOnly = false) => {
    // when only conflict is toggled on, we need to turn off all other notifications
    if (isConflictOnly) {
      handleAction({
        onlyConflictAutoSyncNotification: true,
        // TODO: future: set all others to false
      })
      // TODO: future: else set other local states to false
    } else {
      handleAction({
        onlyConflictAutoSyncNotification: toggle,
      })
    }
    setLocalState(toggle)
  }

  return (
    <div className="card mb-2 automation-notification">
      <h2 className="card-header">
        {intl.get('settings.dss.automationNotification.header')}
      </h2>
      <div className="card-block">
        <div className="mb-2">
          {intl.get('settings.dss.automationNotification.description')}
        </div>
        <div>
          <div
            id="only-conflict-auto-sync-notification"
            className="d-flex align-items-center"
          >
            <input
              type="checkbox"
              checked={onlyConflictAutoSyncNotification}
              onChange={() => {
                handleOnChange(
                  !onlyConflictAutoSyncNotification,
                  setOnlyConflictAutoSyncNotification,
                  !onlyConflictAutoSyncNotification
                )
              }}
              id="composer-settings--automation-notification"
            />
            <label
              htmlFor="composer-settings--automation-notification"
              className="ml-2 my-0"
            >
              {intl.get(
                'settings.dss.automationNotification.conflictOnly.label'
              )}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

AutomationNotification.propTypes = {
  companySettings: PropTypes.object,
  handleAction: PropTypes.func,
}
